<template>
  <div class="transaction-layout-default-block group">
    <div class="transaction-layout-default"
         :class="{'--w-time':displayTime,
                  'actions-enabled':displayActions}">
      <div v-if="displayTime">
        <Time :date="transaction.date" :class="{'opacity-50':transaction.status === 0}"/>
      </div>
      <div class="flex items-center">
        <AccountIcon :icon="transaction.account.icon || ''"
                     :icon-color="transaction.account.icon_color"
                     :icon-bg="transaction.account.icon_bg"
                     :class="{'opacity-50':transaction.status === 0}"/>
        <AccountName :name="transaction.account.title" :class="{'opacity-50':transaction.status === 0}" class="flex-1"/>
      </div>
      <div class="flex items-center">
        <Category v-if="transactionCategory" :category="transactionCategory"
                  :class="{'opacity-50':transaction.status === 0}"
                  class="flex-none max-w-xs"/>
        <Comment v-if="transaction.comment || !!transaction.transfer_id"
                 :class="{'opacity-50':transaction.status === 0}"
                 :transaction="transaction"
                 :comment="transaction.comment"/>
        <div class="ml-auto flex">
          <ExcludedInfo :off-report="transaction.off_report" :off-budget="transaction.off_budget"/>
          <Contractor v-if="!!transaction.contractor && displayContractor"
                      :class="{'opacity-50':transaction.status === 0}"
                      :contractor="transaction.contractor"/>
          <Tags :class="{'opacity-50':transaction.status === 0}" v-if="!!transaction.tags.length"
                :tags="transaction.tags"
                :type="type"/>
          <StatusPending v-if="transaction.status === 0"/>
        </div>
      </div>
      <div class="justify-self-end">
        <Value :sum="transaction.sum"
               :sum-base="transaction.sum_base"
               :class="{'opacity-50':transaction.status === 0}"
               :currency="transaction.account.currency"
               :currency-display="currencyDisplay"
               :isExpense="transaction.type === 2 || transaction.type === 4"
               :type="type"/>
      </div>
      <div v-if="displayActions">
        <Actions @remove="$emit('remove')"
                 @edit="$emit('edit')"/>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import transactionCurrencyDisplayProp from "@/mixins/transactionCurrencyDisplayProp";
import Time from "@/components/common/Transaction/TransactionItem/Time";
import AccountIcon from "@/components/common/Transaction/TransactionItem/AccountIcon";
import AccountName from "@/components/common/Transaction/TransactionItem/AccountName";
import Category from "@/components/common/Transaction/TransactionItem/Category";
import Comment from "@/components/common/Transaction/TransactionItem/Comment";
import Contractor from "@/components/common/Transaction/TransactionItem/Contractor";
import Tags from "@/components/common/Transaction/TransactionItem/Tags";
import Value from "@/components/common/Transaction/TransactionItem/Value";
import Actions from "@/components/common/Transaction/TransactionItem/Actions";
import StatusPending from "@/components/common/Transaction/TransactionItem/StatusPending";
import ExcludedInfo from "@/components/common/Transaction/TransactionItem/ExcludedInfo";

export default {
  name: "TransactionLayoutDefault",
  components: {
    ExcludedInfo,
    StatusPending, AccountName, AccountIcon, Time, Category, Comment, Contractor, Tags, Value, Actions
  },
  mixins: [transactionCurrencyDisplayProp],
  props: {
    transaction: {
      type: Object,
      required: true
    },
    displayTime: {
      type: Boolean,
      required: true
    },
    displayContractor: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters('space', ['currentUserIsWatcher']),
    type() {
      if (!!this.transaction.transfer_id) {
        return 'transfer'
      } else {
        return this.transaction.type === 1 ? 'income' : 'expense'
      }
    },
    transactionCategory() {
      if (this.transaction.type === 1) {
        return this.transaction.income;
      } else {
        return this.transaction.expense;
      }
    },
    displayActions() {
      return !this.currentUserIsWatcher && this.transaction.type !== 4
    }
  }
}
</script>

<style scoped lang="scss">
.transaction-layout-default-block {
  @apply relative;
  &:not(:last-of-type):after {
    @apply bg-border rounded w-full left-0 absolute rounded;
    content: '';
    height: 1px;
    bottom: 1px;
  }
}

.transaction-layout-default {
  @apply flex py-4 items-center col-gap-6 relative;

  > div {
    transition: all .2s;
  }

  &.--w-time {
    > div {

      &:nth-of-type(1) {
        width: 3rem;
      }

      &:nth-of-type(2) {
        width: 22.4%;
        flex: none;
      }

      &:nth-of-type(3) {
        width: 0;
        flex: 1;
      }

      &:nth-of-type(4) {
        @apply -mr-6;
        width: auto;
      }

      &:nth-of-type(5) {
        width: 0;
        opacity: 0;
        overflow: hidden;
      }
    }
  }

  &:not(.--w-time) {
    > div {
      &:nth-of-type(1) {
        width: 22.4%;
      }

      &:nth-of-type(2) {
        width: 0;
        flex: 1;
      }

      &:nth-of-type(3) {
        @apply -mr-6;
        width: auto;
      }

      &:nth-of-type(4) {
        width: 0;
        opacity: 0;
        overflow: hidden;
      }
    }
  }

  &.actions-enabled {
    &.--w-time {
      &:hover {
        > div:nth-of-type(4) {
          @apply -mr-4;
        }

        > div:nth-of-type(5) {
          width: 15px;
          opacity: 1;
        }
      }
    }

    &:not(.--w-time) {
      &:hover {
        > div:nth-of-type(3) {
          @apply -mr-4;
        }

        > div:nth-of-type(4) {
          width: 15px;
          opacity: 1;
        }
      }
    }
  }
}

</style>